import { useState, useEffect } from 'react';
import { useSiteSettings } from '@/context/SiteSettingsContext';
import { buildWhatsAppLink } from '@/utils/whatsapp';

export default function WhatsAppButton() {
  const { settings } = useSiteSettings();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible || !settings.telephone) return null;

  return (
    <a
      href={buildWhatsAppLink(settings.telephone, `Bonjour, j'ai une question sur ${settings.nomSite}.`)}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300 cursor-pointer"
      aria-label="Contacter sur WhatsApp"
    >
      <i className="ri-whatsapp-fill text-white text-2xl" />
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
    </a>
  );
}